(() => {
  if (!['cs', 'en'].includes(document.documentElement.lang)) return;
  const labels = JSON.parse(document.getElementById('pc-option-labels')?.textContent || '{}');
  const translated = value => {
    const normalized = value.trim().replace(/\s+/g, ' ');
    if (labels[normalized]) return value.replace(value.trim(), labels[normalized]);
    const count = normalized.match(/^Zostáva už len\s+(\d+)$/);
    return count ? labels.__stock_many.replace('{n}', count[1]) : value;
  };
  let queued = false;
  const apply = () => {
    queued = false;
    observer.disconnect();
    document.querySelectorAll('.tcustomizer-customization-form').forEach(root => {
      if (root.querySelector('[id^="tcustomizer-field-220579-"]')) return;
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement?.closest('script,style,textarea,input,.tcustomizer-file-item__name')) continue;
        const next = translated(node.textContent);
        if (next !== node.textContent) node.textContent = next;
      }
      root.querySelectorAll('[placeholder],[aria-label],img[alt]').forEach(el => {
        for (const attr of ['placeholder', 'aria-label', 'alt']) {
          const old = el.getAttribute(attr);
          if (old && translated(old) !== old) el.setAttribute(attr, translated(old));
        }
      });
    });
    document.querySelectorAll('.heymerch-stockcount-text').forEach(el => {
      const next = translated(el.textContent);
      if (next !== el.textContent) el.textContent = next;
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  const observer = new MutationObserver(() => {
    if (!queued) { queued = true; requestAnimationFrame(apply); }
  });
  apply();
})();
